export const fileFieldsForSVO = {
    '1': {
        type: 'file',
        name: '1',
        labelForOption: 'Справка о подтверждении факта участия',
        helpText: 'Справка о подтверждении факта участия в специальной военной операции на ' +
            'территориях Украины, Донецкой Народной Республики, Луганской Народной Республики, ' +
            'Запорожской области и Херсонской области, выдаваемая федеральными органами исполнительной власти,' +
            ' федеральными государственными органами в соответствии с Постановлением Правительства Российской ' +
            'Федерации от 9 октября 2024 года № 1354 «О порядке установления факта участия граждан Российской ' +
            'Федерации в специальной военной операции на территориях Украины, Донецкой Народной Республики, ' +
            'Луганской Народной Республики, Запорожской области и Херсонской области»'
    },
    '2': {
        type: 'file',
        name: '2',
        labelForOption: 'Выписка из приказа военного комиссариата',
        helpText: 'Выписка из приказа военного комиссариата о призыве на военную службу по ' +
            'мобилизации в Вооруженные Силы Российской Федерации'
    },
    '3': {
        type: 'file',
        name: '3',
        labelForOption: 'Уведомление о заключении контракта',
        helpText: 'Уведомление федерального органа исполнительной власти о заключении с ' +
            'лицом контракта о прохождении военной службы в соответствии с пунктом 7 статьи 38 ' +
            'Федерального закона от 28 марта 1998 года № 53-ФЗ «О воинской обязанности и военной службе»'
    },
    '4': {
        type: 'file',
        name: '4',
        labelForOption: 'Контракт в рамках мобилизации',
        helpText: 'Копия контракта, заключенного в соответствии с пунктом 7 статьи 38 Федерального ' +
            'закона от 28 марта 1998 года № 53-ФЗ «О воинской обязанности и военной службе»'
    },
    '5': {
        type: 'file',
        name: '5',
        labelForOption: 'Контракт о добровольном содействии',
        helpText: 'Копия (оригинал) контракта о добровольном содействии в выполнении задач, ' +
            'возложенных на Вооруженные Силы Российской Федерации'
    },
    '6': {
        type: 'file',
        name: '6',
        labelForOption: 'Контракт о прохождении военной службы',
        helpText: 'Копия контракта о прохождении военной службы гражданином в Вооруженных Силах ' +
            'Российской Федерации, подтверждающего даты или периоды участия гражданина в специальной ' +
            'военной операции;\n' +
            'медицинские справки и выписки из истории болезни, подтверждающие даты или периоды' +
            ' участия гражданина в специальной военной операции (выполнении боевых задач)'
    }
}